import { render, staticRenderFns } from "./recordingPictureManage.vue?vue&type=template&id=01a5ce4e&scoped=true&"
import script from "./recordingPictureManage.vue?vue&type=script&lang=ts&"
export * from "./recordingPictureManage.vue?vue&type=script&lang=ts&"
import style0 from "./recordingPictureManage.vue?vue&type=style&index=0&id=01a5ce4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a5ce4e",
  null
  
)

export default component.exports